import { generatePath } from 'react-router';
import { paths } from '../../common/constants/pathVariables';
import { useSearchParams } from '../../common/hooks/useSearchParams';
import { omaElisaForCompaniesMsg, t } from '../../common/i18n';
import { getSubscriptionBreadcrumbName, getSubscriptionUrlId } from '../../common/utils/subscriptionUtils';
import { BreadCrumbsWithTitle } from '../BreadCrumbsWithTitle/BreadCrumbsWithTitle';
import { DetailsWrapper } from '../DetailsWrapper';
import { LocalNavi } from '../LocalNavi';
import type { AddOnRulesResponse } from '../../generated/api/addOnRulesResponse';
import type { CompanyInfoResponse } from '../../generated/api/companyInfoResponse';
import type { Contact } from '../../generated/api/contact';
import type { Subscription } from '../../generated/api/subscription';
import type { BreadCrumbNameAndPath } from '../BreadCrumbs';
import type { LocalNaviItem } from '../LocalNavi';
import type { JSX, PropsWithChildren } from 'react';

import './MobileSubscriptionLayout.scss';

export type CategorySubscriptionLayoutProps = PropsWithChildren<{
  addOnRules: AddOnRulesResponse;
  addOnRulesMobilePbx: AddOnRulesResponse;
  companyInfo: CompanyInfoResponse;
  contacts: Contact[];
  subscription: Subscription;
}>;

export type MobileSubscriptionLayoutProps = PropsWithChildren<{
  subscription: Subscription;
  navigationItems: LocalNaviItem[];
  headingTop: string;
  heading: string;
  headingBottom?: string | JSX.Element;
  heroPicto: string;
  categoryBreadcrumbAndPath: BreadCrumbNameAndPath;
}>;

export const getSubscriptionUrl = (path: string, subscription: Subscription, mdmId: string) => {
  return `${generatePath(path, { subscriptionId: getSubscriptionUrlId(subscription) })}?mdmId=${mdmId}`;
};

export const MobileSubscriptionLayout = ({
  children,
  subscription,
  headingTop,
  heading,
  headingBottom,
  heroPicto,
  navigationItems,
  categoryBreadcrumbAndPath,
}: MobileSubscriptionLayoutProps) => {
  const { mdmId } = useSearchParams<{ mdmId: string }>();
  if (!mdmId) {
    throw new Error('missing mdmId');
  }
  return (
    <>
      <DetailsWrapper
        id={`subscription-details-${subscription.subscriptionId}`}
        detailsTop={
          <BreadCrumbsWithTitle
            breadCrumbPaths={[
              { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
              categoryBreadcrumbAndPath,
              { name: getSubscriptionBreadcrumbName(subscription) },
            ]}
          />
        }
        headingTop={headingTop}
        heading={heading}
        headingBottom={headingBottom}
        heroPicto={heroPicto}
        wide
      />
      <div className="of-page-margins--as-margin">
        <LocalNavi wide categories={navigationItems} />
      </div>
      <div className="of-subscription-details">{children}</div>
    </>
  );
};
